module.exports = __webpack_public_path__ + "img/hdc_04.b37ab591.png";